export const PLAYFIELD_UPDATE_LIFE = 'PLAYFIELD_UPDATE_LIFE';


/** WEBPACK FOOTER **
 ** ./src/components/PlayfieldController/constants.js
 **/